import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { useMarketingCopy } from '../context/MarketingCopyContext';
import { faqDefaults } from '../constants/faqDefaults';
import SEOHead from '../components/SEOHead';
import JsonLd from '../components/JsonLd';

export default function FAQ() {
  const { language, t } = useLanguage();
  const { mc } = useMarketingCopy();
  const [openIndex, setOpenIndex] = useState(null);

  const currentFaqs = faqDefaults[language] || faqDefaults.en;
  const categoryKeys = ['services', 'booking', 'pricing', 'general'];
  const categories = categoryKeys.map(cat => [
    t.faq.categories[cat],
    currentFaqs[cat].map((item, idx) => ({
      q: mc('faq', `${cat}.${idx}.q`, item.q),
      a: mc('faq', `${cat}.${idx}.a`, item.a)
    }))
  ]);

  return (
    <div style={{ background: '#0C1220', minHeight: '100vh', paddingTop: 'var(--cjpa-nav-offset)' }}>
      <SEOHead page="faq" />
      <JsonLd data={{
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: categories.flatMap(([, items]) =>
          items.map(item => ({
            '@type': 'Question',
            name: item.q,
            acceptedAnswer: { '@type': 'Answer', text: item.a }
          }))
        )
      }} />
      <div style={{ maxWidth: '900px', margin: '0 auto', padding: 'clamp(2rem, 4vw, 4rem) clamp(1rem, 3vw, 2rem)' }}>

        <div style={{ textAlign: 'center', marginBottom: '5rem' }}>
          <div style={{ fontSize: '0.6rem', letterSpacing: '0.1em', color: '#7C8CA0', textTransform: 'uppercase', marginBottom: '1rem' }}>
            {mc('faq', 'subtitle', t.faq.subtitle)}
          </div>
          <h1 style={{ fontFamily: "'Rajdhani', sans-serif", fontSize: 'clamp(2.5rem, 6vw, 4.5rem)', color: '#E8ECF0', fontWeight: 300 }}>
            {t.faq.title} <span style={{ color: '#D42B2B', fontStyle: 'italic' }}>{t.faq.titleHighlight}</span>
          </h1>
        </div>

        {categories.map(([catName, items], catIdx) => (
          <section key={catName} style={{ marginBottom: '4rem' }}>
            <h2 style={{ fontFamily: "'Rajdhani', sans-serif", fontSize: '2rem', color: '#D42B2B', fontWeight: 300, marginBottom: '2rem' }}>
              {catName}
            </h2>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1px', background: 'rgba(148,163,184,0.08)' }}>
              {items.map((item, idx) => {
                const globalIdx = `${catIdx}-${idx}`;
                const isOpen = openIndex === globalIdx;
                return (
                  <div key={idx} style={{ background: '#111827' }}>
                    <button
                      onClick={() => setOpenIndex(isOpen ? null : globalIdx)}
                      style={{
                        width: '100%', background: 'transparent', border: 'none',
                        padding: '1.5rem 2rem', textAlign: 'left', cursor: 'pointer',
                        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                        color: isOpen ? '#D42B2B' : '#E8ECF0',
                        transition: 'color 0.3s'
                      }}
                    >
                      <span style={{ fontFamily: "'Rajdhani', sans-serif", fontSize: '1.15rem', fontWeight: 400 }}>
                        {item.q}
                      </span>
                      <span style={{ fontSize: '1.5rem', marginLeft: '1rem' }}>
                        {isOpen ? '−' : '+'}
                      </span>
                    </button>
                    {isOpen && (
                      <div style={{
                        padding: '0 2rem 1.5rem 2rem', color: '#64748B',
                        fontSize: '0.9rem', lineHeight: 1.8,
                        borderTop: '1px solid rgba(148,163,184,0.1)'
                      }}>
                        {item.a}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </section>
        ))}

      </div>
    </div>
  );
}
